module.exports = __webpack_public_path__ + "static/img/web-v3-05.a0faec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/web-v3-05.png
// module id = 86QM
// module chunks = 1